import { render, staticRenderFns } from "./paytaro.vue?vue&type=template&id=5d7fefc0&scoped=true&"
import script from "./paytaro.vue?vue&type=script&lang=js&"
export * from "./paytaro.vue?vue&type=script&lang=js&"
import style0 from "./paytaro.vue?vue&type=style&index=0&id=5d7fefc0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7fefc0",
  null
  
)

export default component.exports